<template>
    <div class="row">
        <div class="col-12">
            <label class="form-label">Belge Türü</label>
            <v-validator :errors="errors" parameter="Name" :watch="value.Name">
                <input type="text" v-model="value.Name" class="form-control" placeholder="Belge Türü"/>
            </v-validator>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        value:Object,
        errors:Object
    }
}
</script>

<style>

</style>